import React, { Fragment } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import { Content } from "../../layout/Content";
import propTypes from "../../../constants/propTypes";
import DetailAndCycleContainer from "./DetailAndCycleContainer";
import Terms from "./Terms";

const Wrapper = styled.div`
  margin-top: 24px;
`;

const EntityDetailPage = ({
  backUrl,
  nextItemRoute,
  lastItemRoute,
  entity,
  onOpenEditModal,
  onOpenDeleteModal,
}) => {
  return (
    <Content>
      <Fragment>
        <DetailAndCycleContainer
          entity={entity}
          backUrl={backUrl}
          nextItemRoute={nextItemRoute}
          lastItemRoute={lastItemRoute}
          onOpenEditModal={onOpenEditModal}
          onOpenDeleteModal={onOpenDeleteModal}
        />
        <Wrapper>{entity && <Terms entity={entity} />}</Wrapper>
      </Fragment>
    </Content>
  );
};

EntityDetailPage.propTypes = {
  entity: propTypes.entity,
  onOpenEditModal: PropTypes.func.isRequired,
  onOpenDeleteModal: PropTypes.func.isRequired,
  backUrl: PropTypes.string.isRequired,
  nextItemRoute: PropTypes.string,
  lastItemRoute: PropTypes.string,
};

export default EntityDetailPage;
